
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2020-10-03-with-next-js",
      function () {
        return require("private-next-pages/blogs/2020-10-03-with-next-js/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2020-10-03-with-next-js"])
      });
    }
  